import type { QuestionModule } from "../contracts";
import {
  phoneCore,
  type PhoneDefinition,
  type PhoneDraft,
  type PhoneEvent,
  type PhoneRaw,
  type PhoneResponse,
} from "./core";
import { PhoneView } from "./views";

export const phoneModule: QuestionModule<
  PhoneRaw,
  PhoneDefinition,
  PhoneDraft,
  PhoneEvent,
  PhoneResponse
> = {
  type: "phone_number",
  galleryFeatures: ["baseline", "restored", "country", "prefix"],
  core: phoneCore,
  prompt: (definition) => ({
    content: definition.prompt,
    image: definition.image,
    altText: definition.altText,
    error: definition.error,
  }),
  views: {
    default: {
      id: "default",
      label: "Default",
      component: PhoneView,
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
      input: "custom",
    },
  },
  defaultDisplay: { view: "default" },
  controls: (_definition, _draft, _display, copy) => ({
    inputHint: "multitext",
    primaryAction: {
      purpose: "submit",
      label: copy.actions.send,
      action: { type: "submit" },
    },
  }),
};
